"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hostname = window.location.hostname;
exports.default = hostname === 'localhost' || hostname === '127.0.0.1';
